import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { getBackgroundTheme, getShadowTheme } from '../../../style';
import { tabletWidth, getBrowserDetails, iOSwithHomeBtn, ipadNoHomeButton } from '../../../utils/helpers';
import { Link } from 'react-router-dom';
import WYPIcon from '../../../atoms/icons/WYPIcon';
import { useApp } from '../../../contexts/AppContext';
import RedLine from '../../../atoms/icons/RedLine';

const bottomLength = homeBtn => (homeBtn ? 40 : 30);

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const IconWypContainer = styled('div')(() => ({
  position: 'fixed',
  bottom:
    getBrowserDetails().isIos && getBrowserDetails().isStandaloneMode && !tabletWidth
      ? bottomLength(!iOSwithHomeBtn())
      : bottomLength(ipadNoHomeButton),
  left: '50%',
  width: 55,
  height: 47,
  padding: '13px 5px 0 5px',
  borderRadius: '50%',
  background: getBackgroundTheme().personalInfoBG,
  boxShadow: getShadowTheme().footerLogo,
  transform: 'translate(-50%,0)',
  textAlign: 'center',
  zIndex: 995,
}));

const DiscoverTabStyle = styled('div')<{ isDarkMode: boolean; active: boolean }>(({ isDarkMode, active }) => ({
  fontSize: 12,
  lineHeight: '16px',
  letterSpacing: -0.3,
  paddingTop: 2,
  color: isDarkMode ? '#cfcfcf' : '#212121',
  fontWeight: active ? 700 : 500,
  marginBottom: '-12px',
}));

interface footerLogoProps {
  currentPath: string;
  activePathPattern: any;
  isDarkMode: boolean;
}

const FooterWYPLogo = (props: footerLogoProps): ReactElement => {
  const { currentPath, activePathPattern, isDarkMode } = props;
  const { siteFooterLogoRef } = useApp();
  const isActive = activePathPattern?.test(currentPath);

  return (
    <Link to="/dashboard">
      <IconWypContainer id="IconWypContainer" ref={siteFooterLogoRef}>
        <WYPIcon />
        <DiscoverTabStyle isDarkMode={isDarkMode} active={isActive}>
          Discover
        </DiscoverTabStyle>
        {isActive && <RedLine customStyle={{ width: '100%' }} />}
      </IconWypContainer>
    </Link>
  );
};

export default FooterWYPLogo;
